import { useState, useEffect } from 'react';
import { fetchResumeFromGoogleDrive } from '../services/googleDriveService';
import logger from '../utils/logger';

/**
 * Custom hook to fetch resume URL from Google Drive with fallback to local file
 * @returns {string} Resume URL (Google Drive or local fallback)
 */
export const useResumeUrl = () => {
  const [resumeUrl, setResumeUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadResume = async () => {
      try {
        setIsLoading(true);
        const driveResumeUrl = await fetchResumeFromGoogleDrive();

        if (driveResumeUrl) {
          setResumeUrl(driveResumeUrl);
          logger.log('Successfully loaded resume from Google Drive');
        } else {
          // Fallback to local file
          const localUrl =
            process.env.PUBLIC_URL + 'Anthony Medugno Resume.pdf';
          setResumeUrl(localUrl);
          logger.log('Using local resume file as fallback');
        }
      } catch (error) {
        logger.error('Error loading resume:', error);
        // Fallback to local file
        const localUrl = process.env.PUBLIC_URL + 'Anthony Medugno Resume.pdf';
        setResumeUrl(localUrl);
        logger.log('Using local resume file due to error');
      } finally {
        setIsLoading(false);
      }
    };

    loadResume();
  }, []);

  return { resumeUrl, isLoading };
};
